var DEVICE_TYPE;
(function (DEVICE_TYPE) {
    DEVICE_TYPE["MOBILE"] = "mobile";
    DEVICE_TYPE["TABLET"] = "tablet";
    DEVICE_TYPE["DESKTOP"] = "desktop";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));
var DEVICE_TYPE$1 = DEVICE_TYPE;

export { DEVICE_TYPE$1 as default };
//# sourceMappingURL=DeviceType.js.map
